import { render } from "./ListHistoryItem.vue?vue&type=template&id=b6756642&scoped=true&ts=true"
import script from "./ListHistoryItem.vue?vue&type=script&lang=ts"
export * from "./ListHistoryItem.vue?vue&type=script&lang=ts"

import "./ListHistoryItem.vue?vue&type=style&index=0&id=b6756642&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6756642"]])

export default __exports__